// src/utils/detailedestimation/priceData.ts

// Import des fichiers JSON
import cloisons from '../../data/detailed-estimation-prices/cloisons.json';
import demolition from '../../data/detailed-estimation-prices/demolition.json';
import exterieurs from '../../data/detailed-estimation-prices/exterieurs.json';
import finitions from '../../data/detailed-estimation-prices/finitions.json';
import grosoeuvre from '../../data/detailed-estimation-prices/grosoeuvre.json';
import isolation from '../../data/detailed-estimation-prices/isolation.json';
import menuiserie from '../../data/detailed-estimation-prices/menuiserie.json';
import preparation from '../../data/detailed-estimation-prices/preparation.json';
import revetements from '../../data/detailed-estimation-prices/revetements.json';
import sanitaire from '../../data/detailed-estimation-prices/sanitaire.json';
import technique from '../../data/detailed-estimation-prices/technique.json';
import vrd from '../../data/detailed-estimation-prices/vrd.json';

export interface WorkDetails {
  materials: string[];
  workIncluded: string[];
  performance?: string;
  warranty?: string;
  note?: string;
}

export interface UnitPrice {
  name: string;
  price: number;
  unit: string;
  description: string;
  category: string;
  details?: WorkDetails;
}

// Données structurées des prix avec des clés plates
const priceData = {
  cloisons,
  demolition,
  exterieurs,
  finitions,
  grosoeuvre,
  isolation,
  menuiserie,
  preparation,
  revetements,
  sanitaire,
  technique,
  vrd
};

// Fonction pour récupérer les prix unitaires
export const getUnitPrice = (category: string, key: string): UnitPrice | undefined => {
  // Normaliser la catégorie en retirant les tirets et en minuscules
  const normalizedCategory = category.toLowerCase().replace(/-/g, '');
  const normalizedKey = key.toLowerCase();

  // Log pour le debug
  console.log('Looking for price:', {
    category: normalizedCategory, // Catégorie normalisée
    key: normalizedKey
  });

  // Vérifier si la catégorie existe
  if (!priceData[normalizedCategory as keyof typeof priceData]) {
    console.warn(`Category ${normalizedCategory} not found`);
    return undefined;
  }

  // Récupérer les données de la catégorie
  const categoryData = priceData[normalizedCategory as keyof typeof priceData];

  // Rechercher le prix
  const price = categoryData[normalizedKey];

  if (!price) {
    console.warn(`No price found for ${normalizedKey} in ${normalizedCategory}`);
    console.log('Available keys:', Object.keys(categoryData));
  }

  return price;
};